<div id="container-main-dialog-search-operators" class="container">
  <div class="header">
    <p class="title">
      {{ data.title }}
    </p>
    <button mat-flat-button color="primary" id="regulatory-event-diary-order-dialog-close-button" (click)="close()">
      Cerrar
    </button>
  </div>
  <div class="content">
    <div class="html-container" [innerHTML]="data.event_diary_order"></div>
  </div>
</div>
